import { createContext } from 'react';

const meetingNotesContext = createContext();

export default meetingNotesContext;
